(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initFooterNewsletter = (scope = document) => {
      const form = scope.querySelector('#SiteFooterNewsletterForm');
      if (!form || form.dataset.enhanced === 'true') return;
      const button = form.querySelector('[data-footer-subscribe]');
      const label = form.querySelector('[data-footer-subscribe-label]');
      const sending = button && button.dataset.sendingLabel;
      form.dataset.enhanced = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity() || !button) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = sending;
      });
      const status = form.querySelector('[data-footer-newsletter-status]');
      if (status && window.location.hash === '#SiteFooterNewsletter') status.focus({ preventScroll: true });
    };
    initFooterNewsletter();
    document.addEventListener('shopify:section:load', (event) => initFooterNewsletter(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-faq-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-sl-faq]');

    roots.forEach((root) => {
      if (root.dataset.slFaqReady === 'true') return;
      root.dataset.slFaqReady = 'true';
      root.classList.add('is-enhanced');

      const filters = [...root.querySelectorAll('[data-sl-faq-filter]')];
      const items = [...root.querySelectorAll('[data-sl-faq-item]')];

      items.forEach((item) => {
        const answer = item.querySelector('[data-sl-faq-answer]');
        const summary = item.querySelector('summary');
        if (!answer || !summary) return;

        answer.style.height = item.open ? 'auto' : '0px';

        summary.addEventListener('click', (event) => {
          event.preventDefault();

          if (item.open) {
            answer.style.height = `${answer.scrollHeight}px`;
            requestAnimationFrame(() => {
              answer.style.height = '0px';
            });
            window.setTimeout(() => {
              item.open = false;
            }, 280);
            return;
          }

          item.open = true;
          answer.style.height = '0px';
          requestAnimationFrame(() => {
            answer.style.height = `${answer.scrollHeight}px`;
          });
          answer.addEventListener(
            'transitionend',
            () => {
              if (item.open) answer.style.height = 'auto';
            },
            { once: true },
          );
        });
      });

      filters.forEach((filter) => {
        filter.addEventListener('click', () => {
          const target = filter.dataset.slFaqFilter;
          filters.forEach((button) => {
            button.setAttribute('aria-selected', String(button === filter));
          });
          items.forEach((item) => {
            item.hidden = target !== 'all' && item.dataset.category !== target;
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-general-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initGeneralInquiry = (scope = document) => {
      const form = scope.querySelector('[data-general-inquiry-form]');
      if (!form || form.dataset.enhanced === 'true') return;

      const button = form.querySelector('[data-general-inquiry-submit]');
      const label = form.querySelector('[data-general-inquiry-submit-label]');
      const status = form.querySelector('[role="status"], [role="alert"]');
      form.dataset.enhanced = 'true';

      if (status) status.focus({ preventScroll: true });

      form.addEventListener('submit', () => {
        if (!form.checkValidity() || !button) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (label) label.textContent = button.dataset.sendingLabel;
      });
    };

    initGeneralInquiry();
    document.addEventListener('shopify:section:load', (event) => initGeneralInquiry(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-process-story"] && !Shopify.designMode) return;
  try {
    
  function initSanluceProcessStories() {
    document.querySelectorAll('[data-sl-process-story]').forEach((section) => {
      if (section.dataset.processReady === 'true') return;
      section.dataset.processReady = 'true';

      const pathButtons = section.querySelectorAll('[data-process-path]');
      const chapters = Array.from(section.querySelectorAll('[data-process-stage]'));
      const visuals = Array.from(section.querySelectorAll('[data-process-visual]'));

      function setPath(path) {
        section.dataset.path = path;
        pathButtons.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.processPath === path));
        });
      }

      function setActiveStage(index) {
        chapters.forEach((chapter) => {
          chapter.classList.toggle('is-active', Number(chapter.dataset.processStage) === index);
        });
        visuals.forEach((visual) => {
          visual.classList.toggle('is-active', Number(visual.dataset.processVisual) === index);
        });
      }

      pathButtons.forEach((button) => {
        button.addEventListener('click', () => setPath(button.dataset.processPath));
      });

      if ('IntersectionObserver' in window && window.matchMedia('(min-width: 990px)').matches) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveStage(Number(entry.target.dataset.processStage));
            }
          });
        }, { rootMargin: '-36% 0px -48% 0px', threshold: 0 });

        chapters.forEach((chapter) => observer.observe(chapter));
      }

      document.addEventListener('shopify:block:select', (event) => {
        const chapter = event.target.closest('[data-process-stage]');
        if (chapter && section.contains(chapter)) {
          setActiveStage(Number(chapter.dataset.processStage));
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSanluceProcessStories, { once: true });
  } else {
    initSanluceProcessStories();
  }

  document.addEventListener('shopify:section:load', initSanluceProcessStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-project-brief-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProjectBrief = (root) => {
      if (!root || root.dataset.enhanced === 'true') return;
      const form = root.querySelector('form');
      const steps = Array.from(root.querySelectorAll('[data-project-step]'));
      const nextButton = root.querySelector('[data-project-next]');
      const backButton = root.querySelector('[data-project-back]');
      const submitButton = root.querySelector('[data-project-submit]');
      const progress = root.querySelector('[data-project-progress]');
      const submitLabel = root.querySelector('[data-submit-label]');
      if (!form || steps.length === 0 || !nextButton || !backButton || !submitButton) return;

      const progressTemplate = root.dataset.progressTemplate;
      const sendingLabel = root.dataset.sendingLabel;
      let current = 0;
      root.dataset.enhanced = 'true';

      const showStep = (index, moveFocus = true) => {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => {
          const active = stepIndex === current;
          step.dataset.active = active ? 'true' : 'false';
          step.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        backButton.hidden = current === 0;
        nextButton.style.display = current === steps.length - 1 ? 'none' : '';
        submitButton.style.display = current === steps.length - 1 ? 'inline-flex' : 'none';
        if (progress) progress.textContent = progressTemplate.replace('__CURRENT__', String(current + 1)).replace('__TOTAL__', String(steps.length));
        if (moveFocus) {
          const legend = steps[current].querySelector('legend');
          if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus({ preventScroll: true }); }
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      const validateStep = () => {
        const fields = Array.from(steps[current].querySelectorAll('input, select, textarea'));
        const invalid = fields.find((field) => !field.checkValidity());
        if (!invalid) return true;
        invalid.reportValidity();
        invalid.focus();
        return false;
      };

      nextButton.addEventListener('click', () => { if (validateStep()) showStep(current + 1); });
      backButton.addEventListener('click', () => showStep(current - 1));
      form.addEventListener('submit', (event) => {
        if (!form.checkValidity()) {
          event.preventDefault();
          const invalid = form.querySelector(':invalid');
          const invalidStep = invalid && invalid.closest('[data-project-step]');
          if (invalidStep) showStep(steps.indexOf(invalidStep), false);
          if (invalid) { invalid.reportValidity(); invalid.focus(); }
          return;
        }
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        if (submitLabel) submitLabel.textContent = sendingLabel;
      });
      showStep(0, false);
    };

    document.querySelectorAll('[data-project-brief]').forEach(initProjectBrief);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-project-brief]').forEach(initProjectBrief));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-project-range"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initProjectRange = (root) => {
      if (!root || root.dataset.enhanced === 'true') return;
      const form = root.querySelector('[data-project-range-form]');
      const steps = Array.from(root.querySelectorAll('[data-range-step]'));
      const nextButton = root.querySelector('[data-range-next]');
      const backButton = root.querySelector('[data-range-back]');
      const submitButton = root.querySelector('[data-range-submit]');
      const progress = root.querySelector('[data-range-progress]');
      const result = root.querySelector('[data-range-result]');
      if (!form || steps.length === 0 || !nextButton || !backButton || !submitButton || !result) return;

      let current = 0;
      root.dataset.enhanced = 'true';
      form.hidden = false;

      const showStep = (index, moveFocus = true) => {
        current = Math.max(0, Math.min(index, steps.length - 1));
        steps.forEach((step, stepIndex) => {
          const active = stepIndex === current;
          step.dataset.active = active ? 'true' : 'false';
          step.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        backButton.hidden = current === 0;
        nextButton.style.display = current === steps.length - 1 ? 'none' : '';
        submitButton.style.display = current === steps.length - 1 ? 'inline-flex' : 'none';
        if (progress) progress.textContent = root.dataset.progressTemplate.replace('__CURRENT__', String(current + 1)).replace('__TOTAL__', String(steps.length));
        if (moveFocus) {
          const legend = steps[current].querySelector('legend');
          if (legend) { legend.setAttribute('tabindex', '-1'); legend.focus({ preventScroll: true }); }
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      const validateStep = () => {
        const invalid = Array.from(steps[current].querySelectorAll('input, select')).find((field) => !field.checkValidity());
        if (!invalid) return true;
        invalid.reportValidity();
        invalid.focus();
        return false;
      };

      const getProfile = (data) => {
        const type = data.get('range_project_type');
        const relationship = data.get('range_relationship');
        if (type === 'Architectural home addition') return 'expansion';
        if (['Accessory dwelling unit (ADU)', 'Guest house / private pavilion', 'Backyard studio', 'Private gym / wellness room'].includes(type)) return 'freestanding';
        if (['Sunroom / glass wall system', 'Outdoor kitchen', 'Complete outdoor environment'].includes(type)) return 'integrated';
        if (relationship === 'integrated' || relationship === 'environment') return 'integrated';
        if (type === 'Still defining') return 'exploratory';
        return 'focused';
      };

      const copyToBrief = (data, profile) => {
        const brief = document.querySelector('[data-project-brief]');
        if (!brief) return null;
        const values = {
          profile,
          direction: data.get('range_direction'),
          project_type: data.get('range_project_type'),
          relationship: data.get('range_relationship'),
          footprint: data.get('range_footprint'),
          timeline: data.get('range_timeline'),
          readiness: data.get('range_readiness')
        };

        Object.entries(values).forEach(([key, value]) => {
          const field = brief.querySelector(`[data-range-capture="${key}"]`);
          if (field) field.value = value || '';
        });

        const projectType = brief.querySelector('select[name="contact[project_type]"]');
        if (projectType && values.project_type) projectType.value = values.project_type;
        const dimensions = brief.querySelector('input[name="contact[dimensions]"]');
        if (dimensions && values.footprint) dimensions.value = values.footprint;
        const timeline = brief.querySelector('select[name="contact[timeline]"]');
        if (timeline && values.timeline) timeline.value = values.timeline;

        const solutionMap = { outdoor: 'Outdoor living', freestanding: 'Freestanding living', expansion: 'Home expansion', unsure: 'Still defining' };
        const solution = brief.querySelector(`input[name="contact[solution]"][value="${solutionMap[values.direction] || 'Still defining'}"]`);
        if (solution) solution.checked = true;
        return brief;
      };

      nextButton.addEventListener('click', () => { if (validateStep()) showStep(current + 1); });
      backButton.addEventListener('click', () => showStep(current - 1));

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!validateStep() || !form.checkValidity()) return;
        const data = new FormData(form);
        const profile = getProfile(data);
        const source = root.querySelector(`[data-range-profile="${profile}"]`);
        if (!source) return;

        result.querySelector('[data-range-result-index]').textContent = source.dataset.index;
        result.querySelector('[data-range-result-title]').textContent = source.dataset.title;
        result.querySelector('[data-range-result-copy]').textContent = source.dataset.copy;
        result.querySelector('[data-range-result-factors]').textContent = source.dataset.factors;
        form.hidden = true;
        result.hidden = false;
        result.dataset.profile = profile;
        copyToBrief(data, profile);
        result.focus({ preventScroll: true });
        result.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      root.querySelector('[data-range-to-brief]').addEventListener('click', () => {
        const data = new FormData(form);
        const brief = copyToBrief(data, result.dataset.profile || getProfile(data));
        if (!brief) return;
        brief.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const firstField = brief.querySelector('input:not([type="hidden"]), select, textarea');
        window.setTimeout(() => { if (firstField) firstField.focus({ preventScroll: true }); }, 500);
      });

      root.querySelector('[data-range-restart]').addEventListener('click', () => {
        form.reset();
        result.hidden = true;
        form.hidden = false;
        showStep(0, false);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      showStep(0, false);
    };

    document.querySelectorAll('[data-project-range]').forEach(initProjectRange);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-project-range]').forEach(initProjectRange));
  })();

  } catch(e) { console.error(e); }
})();
})();
